import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';
import {
  DetailedLoadingIndicatorComponent,
  IconComponent,
  OpenWindowDirective
} from '@tdwb/core';
import { FplRestService } from '../services/fpl-rest.service';
import { FplDisclosure } from '../fpl.domain';

@Component({
  selector: 'td-wb-fpl-terms-and-conditions',
  templateUrl: './fpl-terms-and-conditions.component.html',
  styleUrls: ['./fpl-terms-and-conditions.component.scss'],
  imports: [
    TranslateDirective,

    IconComponent,
    OpenWindowDirective,
    DetailedLoadingIndicatorComponent
  ]
})
export class FplTermsAndConditionsComponent {
  private readonly fplRestService = inject(FplRestService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  fplDisclosureContent: SafeHtml;
  loading: boolean = true;

  constructor() {
    this.fplRestService.getFplDisclosure()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (data: FplDisclosure): void => {
          if (data?.fplDisclosure) {
            this.fplDisclosureContent = this.sanitizer.bypassSecurityTrustHtml(data.fplDisclosure);
          }
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        },
        error: (): void => {
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
